<script setup lang="ts">
import AlertIcon from 'vue-material-design-icons/Alert.vue';

export type ContraindicationFoodGroup = {
  group_name: string;
  food_names: string[];
};

const props = defineProps<{
  groups: ContraindicationFoodGroup[];
}>();
</script>

<template>
  <div v-if="props.groups.length" class="border border-yellow-300 rounded flex">
    <div class="bg-yellow-300 p-2 flex items-center justify-center">
      <AlertIcon :size="24" class="text-white" />
    </div>

    <div class="p-4">
      <h2 class="text-yellow-300 font-bold">こんな人は要注意！</h2>
      <ul class="list-disc list-inside text-gray-500 pl-2">
        <li v-for="group in props.groups" :key="group.group_name">
          <span class="font-bold">{{ group.group_name }}</span>
          （{{ group.food_names.join('、') }}）
        </li>
      </ul>
    </div>
  </div>
</template>
